module.exports = __webpack_public_path__ + "img/books.632f7a40.png";